import React from 'react'
import ForgotPasswordStepTwoForm from '../../components/account/forgot-password-step-two-form'

const ForgotPasswordStepTwo = () => {
    return (
        <>
            <ForgotPasswordStepTwoForm />
        </>
    )
}

export default ForgotPasswordStepTwo
